import {OnInit, Component} from '@angular/core';
import {Contest} from './core/contest';
import {DeathService} from './death.service';

@Component({
    moduleId: module.id,
    selector: 'contests',
    templateUrl: './contest.component.html'
})

export class ContestComponent implements OnInit {

    contests: Contest[];

    constructor(private deathService: DeathService) {}

    ngOnInit(): void {
        this.getContests();
    }

    getContests(): void {
        this.deathService
            .getAllContests()
            .subscribe(contests => this.contests = contests);
    }
}



// WEBPACK FOOTER //
// /Users/william/Documents/gitlab/stovokor/src/app/contest.component.ts